/**
 * Team Trips — Destination Marquee Alpine component
 *
 * Wires pause-on-hover to the CSS keyframe that drives the marquee motion
 * (A12 in SPEC_motion.md). The actual movement is performed entirely by the
 * `animate-tt-marquee` Tailwind utility class; this Alpine component only
 * controls `animation-play-state` by toggling a class on the track element.
 *
 * Reduced-motion: the CSS `@media (prefers-reduced-motion: reduce)` block in
 * app.css already kills the animation at the CSS level, so no JS check is
 * strictly required — but we honour it here as well so the hover listeners
 * are never added when they won't have any effect.
 */
export default function marquee() {
    const reduced = typeof window !== 'undefined'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return {
        /** True when the marquee should be paused. */
        paused: false,

        /** Pause the marquee (used by @mouseenter / @focusin handlers). */
        pause() {
            if (!reduced) {
                this.paused = true;
            }
        },

        /** Resume the marquee (used by @mouseleave / @focusout handlers). */
        resume() {
            this.paused = false;
        },
    };
}
